import { array, arrayOf, bool, shape, string } from 'prop-types'

export const offCanvasCategory = shape({
  name: string,
  hasSubCategories: bool,
  id: string,
  canonicalUrl: string,
  subCategories: array,
})

export const offCanvasNewHeader = arrayOf(
  shape({
    id: string,
    icon: string,
    label: string,
  })
)
